var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeatherUpload = function SvgFeatherUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84.227,
    viewBox: "0 0 84 84.227",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill-opacity:0;fill:none;stroke:#db1a16;stroke-linecap:round;stroke-width:6px;}.b{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.245 -0.257)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M82.059,22.434l-.084,25.717H4.5V22.5h0",
    transform: "translate(0 33.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M53.278,25.889,31.889,4.5,10.5,25.889",
    transform: "translate(11.111 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18,4.5V55.833",
    transform: "translate(25 0)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeatherUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feather-upload.f2b324d6.svg";
export { ForwardRef as ReactComponent };